import React, { useState } from "react";
import {
  Card,
  CardMedia,
  Box,
  Typography,
  CircularProgress,
  Fade,
  List,
  ListItem,
  ListItemText,
} from "@mui/material";
import {
  PRIMARY_COLOR,
  SECONDARY_COLOR,
  TERTIARY_COLOR,
} from "../consts/colors";

export const ProductCard: React.FC<{
  id: number;
  name: string;
  price: number;
  size: number;
  imageUrl: string;
  specifications: string[];
}> = ({ id, name, price, size, imageUrl, specifications }) => {
  const [checked, setChecked] = useState(false);
  const [imageLoaded, setImageLoaded] = useState(false);

  const handleImageLoad = () => {
    setImageLoaded(true);
  };

  return (
    <Card
      sx={{
        maxWidth: window.innerWidth,
        height: window.innerWidth * 1.25,
        margin: "4px",
        position: "relative",
        color: SECONDARY_COLOR,
        backgroundColor: PRIMARY_COLOR,
      }}
      key={`productCard-${id}`}
      onClick={() => setChecked(!checked)}
    >
      {/* spinning component */}
      {!imageLoaded && (
        <Box
          sx={{
            position: "absolute",
            backgroundColor: PRIMARY_COLOR,
            height: "100%",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <CircularProgress sx={{ color: SECONDARY_COLOR }} size={80} />
        </Box>
      )}

      <Fade in={checked}>
        <Box
          sx={{
            position: "absolute",
            zIndex: 5,
            borderRadius: 1,
            display: "flex",
            width: "100%",
            height: "100%",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column",
          }}
        >
          <Box
            sx={{
              backgroundColor: PRIMARY_COLOR,
              width: "auto",
              margin: "10px 15px",
              padding: "25px 25px",
              borderRadius: 2,
            }}
          >
            <Typography
              variant="h6"
              sx={{
                fontFamily: "Tenor Sans",
                fontWeight: "bold",
                whiteSpace: "normal",
              }}
            >
              Specification
            </Typography>
            <List
              dense={true}
              style={{
                maxHeight: "calc(100% - 40px)",
                overflow: "auto",
              }}
            >
              {specifications.map((specification, index) => (
                <ListItem
                  key={`product-${id}-detail-${index}`}
                  sx={{ paddingY: 0 }}
                >
                  <ListItemText
                    primary={specification}
                    primaryTypographyProps={{
                      style: {
                        color: TERTIARY_COLOR,
                        fontWeight: "bold",
                        fontFamily: "Tenor Sans",
                      },
                    }}
                    secondaryTypographyProps={{
                      style: {
                        color: TERTIARY_COLOR,
                        fontFamily: "Tenor Sans",
                      },
                    }}
                  />
                </ListItem>
              ))}
            </List>
          </Box>
        </Box>
      </Fade>

      <CardMedia
        sx={{ width: "100%", height: "100%" }}
        image={imageUrl}
        component={"img"}
        onLoad={handleImageLoad}
      />

      {imageLoaded && (
        <Box
          sx={{
            position: "absolute",
            padding: "15px 15px",
            bottom: 0,
            left: 0,
            right: 0,
            color: TERTIARY_COLOR,
          }}
        >
          <Box
            sx={{
              height: "100%",
              width: "100%",
              background:
                "linear-gradient(0deg, rgba(0,0,0,1) 0%, rgba(0,0,0,0.3) 61%, rgba(255,255,255,0) 100%)",
              position: "absolute",
              bottom: 0,
              left: 0,
              zIndex: 0,
            }}
          />
          <Typography
            variant="subtitle1"
            sx={{
              fontFamily: "Tenor Sans",
              fontWeight: "bold",
              opacity: 0.8,
              zIndex: 3,
              width: "100%",
              whiteSpace: "normal",
            }}
          >
            {name}
          </Typography>
          <Typography
            variant="h5"
            sx={{ fontFamily: "Tenor Sans", opacity: 0.8, zIndex: 3 }}
          >
            {`Size ${size} | $${price}`}
          </Typography>
        </Box>
      )}

      {/* Shadow */}
    </Card>
  );
};
